import { render } from "./MediaIcons.vue?vue&type=template&id=5fcc1d5e&scoped=true"
import script from "./MediaIcons.vue?vue&type=script&lang=js"
export * from "./MediaIcons.vue?vue&type=script&lang=js"

import "./MediaIcons.vue?vue&type=style&index=0&id=5fcc1d5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcc1d5e"]])

export default __exports__